<template>
<div class="panel stock-list">
  <div class="panel-heading text-force-align">
    <div class="text-right">
      ストックリスト
    </div>
    <div class="text-left" v-if="is_show_edit_button">
      <b-icon icon="sort" style="margin-left:1em;"
        v-bind:type="{'is-danger': is_sort}"
        @click.native="is_sort = !is_sort; is_edit = false;">
      </b-icon>
      <b-icon icon="edit" style="margin-left:1em;"
        v-bind:type="{'is-danger': is_edit}"
        @click.native="is_edit = !is_edit; is_sort = false;">
      </b-icon>
    </div>
  </div>
  <p class="panel-tabs">
    <a class="is-active">自分のストック</a>
    <router-link class="has-text-danger" to="/followstock">他人のストック</router-link>
  </p>
  <router-link class="panel-block text-force-align"
    v-for="lst in create_list" :key="lst.list_id"
    :to="(is_edit || is_sort) ? '' : '/stock/'+lst.list_id">
    <div class="text-right">
      <b-icon icon="book" size="is-small" type="is-danger"></b-icon>
      {{lst.list_name}} <span class="is-size-7 has-text-grey">({{lst.length}})</span>
    </div>
    <p class="text-left">
      <a class="button is-rounded is-small is-success" style="margin-right:0.5em;" v-if="is_sort"
         @click="$store.dispatch('changeCreateListOrderUp', lst.list_id)">
        <b-icon icon="chevron-up" size="is-small"></b-icon>
      </a>
      <a class="button is-rounded is-small is-success" v-if="is_sort"
         @click="$store.dispatch('changeCreateListOrderDown', lst.list_id)">
        <b-icon icon="chevron-down" size="is-small"></b-icon>
      </a>
      <a class="button is-rounded is-small is-success" style="margin-right:0.5em;" v-if="is_edit"
         @click="showStockRenamePrompt(lst.list_id, lst.list_name)">
        <b-icon icon="pencil" size="is-small"></b-icon>
      </a>
      <a class="button is-rounded is-small is-danger" @click="confirmCustomDelete(lst.list_id, lst.list_name)" v-if="is_edit">
        <b-icon icon="minus" size="is-small"></b-icon>
      </a>
    </p>
  </router-link>
  <b-field style="margin-top:1em;" v-if="is_edit">
    <b-input placeholder="新しいストックの名前" v-model="new_list_name"
      minlength="3" maxlength="30" expanded></b-input>
    <p class="control">
        <span class="button is-success" @click="create_mylist()">作成</span>
    </p>
  </b-field>
</div>
</template>

<script>
export default {
  title: "- 自分のストック",
  data() {
    return {
      create_list: [],
      new_list_name: "",
      is_edit: false,
      is_sort: false,
      delete_list_id: "",
    }
  },
  props: {
    is_show_edit_button: {
      type: Boolean,
      default: true,
    }
  },
  computed: {
    user_info: function () {
      let ret_info = this.$store.getters['getUserInfo']
      return JSON.parse(JSON.stringify(ret_info))
    }
  },
  watch: {
    user_info: {
      handler: "get_createlists",
      immediate: true,      
    },
  },
  methods: {
    create_mylist() {
      this.$store.dispatch("createNewMylist", this.new_list_name).then((result) => {
        if(result == true){
          this.$buefy.toast.open('新しいストックを作成しました！')
        }
        else{
          this.$buefy.toast.open(`「${this.new_list_name}」は作成できないストック名です`)
        }
        this.new_list_name = ""
      }).catch((err) => {
        console.error(err)
        this.$buefy.toast.open('ストックが作成できませんでした')
      })
    },
    delete_mylist(list_id) {
      this.$store.dispatch("deleteMylist", list_id)
    },
    confirmCustomDelete(list_id, list_name) {
      this.delete_list_id = list_id
      this.$buefy.dialog.confirm({
        message: `本当に「${list_name}」を削除しますか？`,
        cancelText: 'キャンセル',
        confirmText: '削除する',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => {
          this.delete_mylist(list_id)
        }
      })
    },
    get_createlists() {
      this.create_list = this.$store.getters.getCreateLists.map((val) => {
        val.length = this.$store.getters.getCreateListLength(val.list_name)
        return val
      })
      this.create_list.splice()
    },
    showStockRenamePrompt(list_id, list_name) {
      this.$buefy.dialog.prompt({
        message: `「${list_name}」のストック名を変更`,
        inputAttrs: {
          maxlength: 20
        },
        trapFocus: true,
        cancelText: 'キャンセル',
        confirmText: '名前を変更する',
        onConfirm: (value) => {
          const list_info = {list_id:list_id, list_name:value}
          this.$store.dispatch("changeCreateListName", list_info)
        }
      })
    }
  }
}
</script>

<style scoped>
.stock-list { max-width: 800px;}

@media screen and (min-width: 1100px){
  .stock-list{ 
    max-width: 800px;
    margin-top: 20px;
  }
}

.text-force-align { display: table; width: 100%;}
.text-right { display: table-cell; text-align: left; }
.text-center  { display: table-cell; text-align: center; }
.text-left     { display: table-cell; text-align: right; }
</style>